export default {
  FETCH_AVAILABLE_PACKAGES_COMPLETE: '@YOLA_EDITOR/FEATURES/FETCH_AVAILABLE_PACKAGES_COMPLETE',
};
